import React from 'react';
import styled from 'styled-components';
import Row from 'components/Common/Row';
import Typography from 'kingpin/atoms/Typography';
import MicrosoftIcon from '../MicrosoftIcon';
import ReviewSteps, { ReviewStep } from './ReviewSteps';

const HeadingDiv = styled(Row)`
  margin-bottom: 24px;
  padding-bottom: 24px;
  box-shadow: var(--shadow-inset);
`;

const Heading = ({ step }: { step?: ReviewStep }) => (
  <HeadingDiv spaceBetween centerAlign>
    <Row centerAlign>
      <MicrosoftIcon />
      <Typography.Header type="H4">Microsoft SSO Integration</Typography.Header>
    </Row>
    {step && <ReviewSteps current={step} />}
  </HeadingDiv>
);

export default Heading;
